import { GenericCollectionFactory } from "../../_generics";
import { GENERIC_IDS } from "../../_constants/generics.constants";

export const ClockinWorkingCalendarStore = GenericCollectionFactory(GENERIC_IDS.CLOCKINS_WORKING_CALENDAR, "uid");
